module.exports = __webpack_public_path__ + "img/chenggong.4684b9f0.png";